<div class="d-flex mt-3">
  <div class="card__amount">
    <div class="card__amount__description">Requested</div>
    <div class="card__amount__value">
      {{ requestedAmount()?.amount > 0 ? (requestedAmount() | uiCurrency) : '-' }}
    </div>
  </div>
  <div class="card__amount">
    <div class="card__amount__description">
      {{ isPaid() ? 'Paid' : 'Approved' }}
    </div>
    <div class="card__amount__value">
      {{ approvedAmount()?.amount > 0 ? (approvedAmount() | uiCurrency) : '-' }}
      @if (isPaid()) {
        <ui-icon icon="check-single" color="green" class="ms-1" />
      }
    </div>
  </div>
</div>
